/*
 *
 * ReportTemplates constants
 *
 */

export const FETCH_REPORT_TEMPLATES_REQUEST =
  'app/ReportTemplates/FETCH_REPORT_TEMPLATES_REQUEST';
export const FETCH_REPORT_TEMPLATES_SUCCESS =
  'app/ReportTemplates/FETCH_REPORT_TEMPLATES_SUCCESS';
export const FETCH_REPORT_TEMPLATES_FAILURE =
  'app/ReportTemplates/FETCH_REPORT_TEMPLATES_FAILURE';

export const FETCH_SINGLE_REPORT_TEMPLATE_REQUEST =
  'app/ReportTemplates/FETCH_SINGLE_REPORT_TEMPLATE_REQUEST';
export const FETCH_SINGLE_REPORT_TEMPLATE_SUCCESS =
  'app/ReportTemplates/FETCH_SINGLE_REPORT_TEMPLATE_SUCCESS';
export const FETCH_SINGLE_REPORT_TEMPLATE_FAILURE =
  'app/ReportTemplates/FETCH_SINGLE_REPORT_TEMPLATE_FAILURE';

export const DUPLICATE_REPORT_TEMPLATE_REQUEST =
  'app/ReportTemplates/DUPLICATE_REPORT_TEMPLATE_REQUEST';
export const DUPLICATE_REPORT_TEMPLATE_SUCCESS =
  'app/ReportTemplates/DUPLICATE_REPORT_TEMPLATE_SUCCESS';
export const DUPLICATE_REPORT_TEMPLATE_FAILURE =
  'app/ReportTemplates/DUPLICATE_REPORT_TEMPLATE_FAILURE';

export const ADD_REPORT_TEMPLATE_REQUEST =
  'app/ReportTemplates/ADD_REPORT_TEMPLATE_REQUEST';
export const ADD_REPORT_TEMPLATE_SUCCESS =
  'app/ReportTemplates/ADD_REPORT_TEMPLATE_SUCCESS';
export const ADD_REPORT_TEMPLATE_FAILURE =
  'app/ReportTemplates/ADD_REPORT_TEMPLATE_FAILURE';

export const UPDATE_REPORT_TEMPLATE_REQUEST =
  'app/ReportTemplates/UPDATE_REPORT_TEMPLATE_REQUEST';
export const UPDATE_REPORT_TEMPLATE_SUCCESS =
  'app/ReportTemplates/UPDATE_REPORT_TEMPLATE_SUCCESS';
export const UPDATE_REPORT_TEMPLATE_FAILURE =
  'app/ReportTemplates/UPDATE_REPORT_TEMPLATE_FAILURE';

export const GENERATE_TEST_REPORT_REQUEST =
  'app/ReportTemplates/GENERATE_TEST_REPORT_REQUEST';
export const GENERATE_TEST_REPORT_SUCCESS =
  'app/ReportTemplates/GENERATE_TEST_REPORT_SUCCESS';
export const GENERATE_TEST_REPORT_FAILURE =
  'app/ReportTemplates/GENERATE_TEST_REPORT_FAILURE';

export const DELETE_REPORT_TEMPLATE_REQUEST =
  'app/ReportTemplates/DELETE_REPORT_TEMPLATE_REQUEST';
export const DELETE_REPORT_TEMPLATE_SUCCESS =
  'app/ReportTemplates/DELETE_REPORT_TEMPLATE_SUCCESS';
export const DELETE_REPORT_TEMPLATE_FAILURE =
  'app/ReportTemplates/DELETE_REPORT_TEMPLATE_FAILURE';

export const UPLOAD_REPORT_TEMPLATE_LOGO_REQUEST =
  'app/ReportTemplates/UPLOAD_REPORT_TEMPLATE_LOGO_REQUEST';
export const UPLOAD_REPORT_TEMPLATE_LOGO_SUCCESS =
  'app/ReportTemplates/UPLOAD_REPORT_TEMPLATE_LOGO_SUCCESS';
export const UPLOAD_REPORT_TEMPLATE_LOGO_FAILURE =
  'app/ReportTemplates/UPLOAD_REPORT_TEMPLATE_LOGO_FAILURE';

export const DELETE_REPORT_TEMPLATE_LOGO_REQUEST =
  'app/ReportTemplates/DELETE_REPORT_TEMPLATE_LOGO_REQUEST';
export const DELETE_REPORT_TEMPLATE_LOGO_SUCCESS =
  'app/ReportTemplates/DELETE_REPORT_TEMPLATE_LOGO_SUCCESS';
export const DELETE_REPORT_TEMPLATE_LOGO_FAILURE =
  'app/ReportTemplates/DELETE_REPORT_TEMPLATE_LOGO_FAILURE';

export const UPLOAD_COVER_LETTER_CUSTOM_LOGO_REQUEST =
  'app/ReportTemplates/UPLOAD_COVER_LETTER_CUSTOM_LOGO_REQUEST';
export const UPLOAD_COVER_LETTER_CUSTOM_LOGO_SUCCESS =
  'app/ReportTemplates/UPLOAD_COVER_LETTER_CUSTOM_LOGO_SUCCESS';
export const UPLOAD_COVER_LETTER_CUSTOM_LOGO_FAILURE =
  'app/ReportTemplates/UPLOAD_COVER_LETTER_CUSTOM_LOGO_FAILURE';

export const DELETE_COVER_LETTER_CUSTOM_LOGO_REQUEST =
  'app/ReportTemplates/DELETE_COVER_LETTER_CUSTOM_LOGO_REQUEST';
export const DELETE_COVER_LETTER_CUSTOM_LOGO_SUCCESS =
  'app/ReportTemplates/DELETE_COVER_LETTER_CUSTOM_LOGO_SUCCESS';
export const DELETE_COVER_LETTER_CUSTOM_LOGO_FAILURE =
  'app/ReportTemplates/DELETE_COVER_LETTER_CUSTOM_LOGO_FAILURE';

export const ADD_TEMPLATE_SECTION_REQUEST =
  'app/ReportTemplates/ADD_TEMPLATE_SECTION_REQUEST';
export const ADD_TEMPLATE_SECTION_SUCCESS =
  'app/ReportTemplates/ADD_TEMPLATE_SECTION_SUCCESS';
export const ADD_TEMPLATE_SECTION_FAILURE =
  'app/ReportTemplates/ADD_TEMPLATE_SECTION_FAILURE';

export const UPDATE_TEMPLATE_SECTION_REQUEST =
  'app/ReportTemplates/UPDATE_TEMPLATE_SECTION_REQUEST';
export const UPDATE_TEMPLATE_SECTION_SUCCESS =
  'app/ReportTemplates/UPDATE_TEMPLATE_SECTION_SUCCESS';
export const UPDATE_TEMPLATE_SECTION_FAILURE =
  'app/ReportTemplates/UPDATE_TEMPLATE_SECTION_FAILURE';

export const DELETE_TEMPLATE_SECTION_REQUEST =
  'app/ReportTemplates/DELETE_TEMPLATE_SECTION_REQUEST';
export const DELETE_TEMPLATE_SECTION_SUCCESS =
  'app/ReportTemplates/DELETE_TEMPLATE_SECTION_SUCCESS';
export const DELETE_TEMPLATE_SECTION_FAILURE =
  'app/ReportTemplates/DELETE_TEMPLATE_SECTION_FAILURE';

export const ADD_SECTION_CASE_REQUEST =
  'app/ReportTemplates/ADD_SECTION_CASE_REQUEST';
export const ADD_SECTION_CASE_SUCCESS =
  'app/ReportTemplates/ADD_SECTION_CASE_SUCCESS';
export const ADD_SECTION_CASE_FAILURE =
  'app/ReportTemplates/ADD_SECTION_CASE_FAILURE';

export const UPDATE_SECTION_CASE_REQUEST =
  'app/ReportTemplates/UPDATE_SECTION_CASE_REQUEST';
export const UPDATE_SECTION_CASE_SUCCESS =
  'app/ReportTemplates/UPDATE_SECTION_CASE_SUCCESS';
export const UPDATE_SECTION_CASE_FAILURE =
  'app/ReportTemplates/UPDATE_SECTION_CASE_FAILURE';

export const DELETE_SECTION_CASE_REQUEST =
  'app/ReportTemplates/DELETE_SECTION_CASE_REQUEST';
export const DELETE_SECTION_CASE_SUCCESS =
  'app/ReportTemplates/DELETE_SECTION_CASE_SUCCESS';
export const DELETE_SECTION_CASE_FAILURE =
  'app/ReportTemplates/DELETE_SECTION_CASE_FAILURE';

export const DELETE_SECTION_CASE_IMAGE_REQUEST =
  'app/ReportTemplates/DELETE_SECTION_CASE_IMAGE_REQUEST';
export const DELETE_SECTION_CASE_IMAGE_SUCCESS =
  'app/ReportTemplates/DELETE_SECTION_CASE_IMAGE_SUCCESS';
export const DELETE_SECTION_CASE_IMAGE_FAILURE =
  'app/ReportTemplates/DELETE_SECTION_CASE_IMAGE_FAILURE';

export const SELECT_REPORT_TEMPLATE =
  'app/ReportTemplates/SELECT_REPORT_TEMPLATE';

export const SELECT_TEMPLATE_SECTION =
  'app/ReportTemplates/SELECT_TEMPLATE_SECTION';

export const ReportFor = {
  participant: 'participant',
  thirdParty: 'third_party',
  henryFordHealth: 'henry_ford_health',
};

export const REORDER_TEMPLATE_SECTIONS_REQUEST =
  'app/ReportTemplates/REORDER_TEMPLATE_SECTIONS_REQUEST';
export const REORDER_TEMPLATE_SECTIONS_SUCCESS =
  'app/ReportTemplates/REORDER_TEMPLATE_SECTIONS_SUCCESS';
export const REORDER_TEMPLATE_SECTIONS_ERROR =
  'app/ReportTemplates/REORDER_TEMPLATE_SECTIONS_ERROR';

export const REORDER_SECTION_CASES_REQUEST =
  'app/ReportTemplates/REORDER_SECTION_CASES_REQUEST';
export const REORDER_SECTION_CASES_SUCCESS =
  'app/ReportTemplates/REORDER_SECTION_CASES_SUCCESS';
export const REORDER_SECTION_CASES_FAILURE =
  'app/ReportTemplates/REORDER_SECTION_CASES_FAILURE';
